import { Injectable, Signal } from '@angular/core';
// import { IUtmModel } from '@partners/utm';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IUtmState, UtmActions, UtmSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class UtmStore extends StateAccessService<IUtmState> {
  readonly state$: Observable<IUtmState>;

  // readonly utmParams$$: Signal<IUtmModel>;
  readonly utmParams$$: Signal<IUtmState>;

  constructor() {
    super();

    this.utmParams$$ = this.stateFacade.selectSignal$(UtmSelectors.utmState);
  }

  dispatchUtmReset() {
    this.stateFacade.dispatch(UtmActions.reset());
  }

  dispatchUtmLoad(model: IUtmState) {
    this.stateFacade.dispatch(UtmActions.loadParams({ model }));
  }
}
